// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__1fpW5","cell":"ColumnAccessor_cell__1TFnG","firstCellAccent":"ColumnAccessor_firstCellAccent__2KIFo"};